import { matchPath } from 'react-router-dom';

// Role 4 = EDC (economic development). They use CodeSoft as a CRM for business
// and property owners: businesses, contacts, properties, licenses, follow-ups.
// Code-enforcement pages are off-limits; the backend returns 403 for them and
// shows EDC only enforcement counts (see EnforcementSummaryCard).
export const EDC_ROLE = 4;
export const EDC_HOME_PATH = '/crm/dashboard';

const EDC_ROUTE_PATTERNS = [
  '/vacancies',
  '/crm/dashboard',
  '/crm/reports',
  '/crm/follow-ups',
  '/crm/spaces',
  '/crm/programs',
  '/crm/events',
  '/crm/timelines',
  '/crm/timelines/:id',
  '/available-spaces',
  '/businesses',
  '/business/:id',
  '/contacts',
  '/contacts/:id',
  '/address/:id',
  '/map',
  '/licenses',
  '/license/:id',
  '/account',
  '/notifications',
];

export function isEdcUser(user) {
  return (user?.user_type || 'staff') === 'staff' && Number(user?.role) === EDC_ROLE;
}

// Mirrors get_current_staff_user; CRM access alone does not grant these actions.
export function canManageStaffRecords(user) {
  return user?.user_type === 'staff' && [1, 2, 3].includes(Number(user?.role));
}

// Mirrors get_current_issuing_user: final license/permit approval and delivery
// belong to OAS (role 2), with admins (role 3) able to cover.
export function canIssueLicensesAndPermits(user) {
  return user?.user_type === 'staff' && [2, 3].includes(Number(user?.role));
}

export function isEdcAllowedPath(pathname) {
  return EDC_ROUTE_PATTERNS.some((path) => matchPath({ path, end: true }, pathname));
}
